import React from 'react';
import Weekview from './Weekview';

export default function Calendar({
  calendarWeeks,
  timeSlots,
  scheduledMovies,
  getScheduledMovieForSlot,
  isSlotOccupied,
  handleDragOver,
  handleDrop,
  removeScheduledMovie,
  setDraggedMovie,
  getStreamingServiceById,
  isAdmin = false,
  onArchiveWeek,
  onDeleteWeek,
  getWeekKey,
  isWeekViewable,
  toggleWeekViewable
}) {
  return (
    <div className="flex-1 bg-gray-800 border-2 border-orange-600 rounded-lg shadow-2xl overflow-hidden">
      <div className="p-4 border-b border-orange-600">
        <h2 className="text-lg font-bold text-orange-300">🗓️ Horror Movie Schedule</h2>
        <p className="text-sm text-orange-200">
          Drag movies from the library to schedule them
        </p>
      </div>
      
      <div className="overflow-auto" style={{ height: 'calc(100% - 80px)' }}>
        {calendarWeeks.map((week, weekIndex) => {
          const weekKey = getWeekKey ? getWeekKey(week) : null;
          const isViewable = isWeekViewable ? isWeekViewable(week) : true;
          
          return (
          <div key={weekIndex}>
            {/* Week Header with Controls */}
            {isAdmin && (
              <div className="bg-gray-700 border-b border-orange-500 px-4 py-2 flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <h3 className="text-orange-300 font-bold text-sm">
                    📅 {week[0].toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - {week[6].toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: week[0].getFullYear() !== week[6].getFullYear() ? 'numeric' : undefined })}
                  </h3>
                  
                  {/* Visibility Status Indicator */}
                  <span className={`text-xs font-bold px-2 py-1 rounded ${
                    isViewable 
                      ? 'bg-green-600 text-white' 
                      : 'bg-red-600 text-white'
                  }`}>
                    {isViewable ? '👁️ Public' : '🔒 Hidden'}
                  </span>
                </div>
                
                <div className="flex items-center gap-2">
                  {/* Visibility Toggle */}
                  <button
                    onClick={() => toggleWeekViewable && toggleWeekViewable(weekKey)}
                    className={`px-3 py-1 rounded-md text-xs font-bold transition-colors ${
                      isViewable
                        ? 'bg-red-600 hover:bg-red-500 text-white'
                        : 'bg-green-600 hover:bg-green-500 text-white'
                    }`}
                    title={isViewable ? 'Hide from public view' : 'Make public'}
                  >
                    {isViewable ? '🔒 Hide' : '👁️ Show'}
                  </button>
                  
                  {/* Archive Button */}
                  <button
                    onClick={() => onArchiveWeek && onArchiveWeek(week)}
                    className="bg-purple-600 hover:bg-purple-500 text-white px-3 py-1 rounded-md text-xs font-bold transition-colors"
                    title="Archive this week"
                  >
                    📦 Archive
                  </button>

                  {/* Delete Button */}
                  <button
                    onClick={() => onDeleteWeek && onDeleteWeek(week)}
                    className="bg-red-600 hover:bg-red-500 text-white px-3 py-1 rounded-md text-xs font-bold transition-colors"
                    title="Permanently delete this week"
                  >
                    🗑️ Delete
                  </button>
                </div>
              </div>
            )}
            
            <Weekview
              week={week}
              timeSlots={timeSlots}
              scheduledMovies={scheduledMovies}
              getScheduledMovieForSlot={getScheduledMovieForSlot}
              isSlotOccupied={isSlotOccupied}
              handleDragOver={handleDragOver}
              handleDrop={handleDrop}
              removeScheduledMovie={removeScheduledMovie}
              setDraggedMovie={setDraggedMovie}
              getStreamingServiceById={getStreamingServiceById}
            />
          </div>
          );
        })}
      </div>
    </div>
  );
}
